var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/segment.ts
import { AnalyticsBrowser } from "@segment/analytics-next";

// src/geolocation.ts
var getGeolocation = () => __async(void 0, null, function* () {
  const timeToWait = process.env.NODE_ENV === "test" ? 200 : 5e3;
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      console.warn("Geolocaliza\xE7\xE3o n\xE3o \xE9 suportada pelo navegador.");
      resolve({ latitude: null, longitude: null });
      return;
    }
    const timeout = setTimeout(() => {
      console.warn("Tempo limite para obter geolocaliza\xE7\xE3o excedido.");
      resolve({ latitude: null, longitude: null });
    }, timeToWait);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        clearTimeout(timeout);
        const { latitude, longitude } = position.coords;
        resolve({ latitude, longitude });
      },
      (error) => {
        console.error("Erro ao obter geolocaliza\xE7\xE3o:", error);
        resolve({ latitude: null, longitude: null });
      },
      {
        enableHighAccuracy: false,
        timeout: timeToWait
      }
    );
  });
});

// src/segment.ts
var _SegmentService = class _SegmentService {
  constructor() {
    __publicField(this, "analytics", null);
    __publicField(this, "analyticsInstance", null);
    __publicField(this, "context", null);
    __publicField(this, "cachedLocation");
  }
  static getInstance() {
    if (!_SegmentService.instance) {
      _SegmentService.instance = new _SegmentService();
    }
    return _SegmentService.instance;
  }
  fetchLocation() {
    return __async(this, null, function* () {
      try {
        const location = yield getGeolocation();
        if (location) {
          this.cachedLocation = location;
          console.log("Localiza\xE7\xE3o capturada:", location);
        } else {
          console.warn("Geolocaliza\xE7\xE3o n\xE3o dispon\xEDvel.");
        }
      } catch (error) {
        this.logError("Erro ao capturar geolocaliza\xE7\xE3o", error);
      }
    });
  }
  appendLocation(props) {
    var _a;
    return __spreadValues(__spreadValues({}, props), (_a = this.cachedLocation) != null ? _a : {});
  }
  initOptions(options) {
    return __async(this, null, function* () {
      if (options.geolocation) {
        yield this.fetchLocation();
      }
    });
  }
  logError(context, error) {
    console.error(`[SegmentService] ${context}:`, error);
  }
  getIntegrationOptions() {
    return { integrations: { All: true } };
  }
  init(_0) {
    return __async(this, arguments, function* (writeKey, options = { geolocation: true }) {
      if (!writeKey) {
        console.warn("Segment n\xE3o foi inicializado: Write Key nao foi fornecida.");
        return;
      }
      try {
        if (typeof window !== "undefined") {
          console.log("SegmentService.init", "loading analytics");
          this.analyticsInstance = new AnalyticsBrowser();
          const [analytics, context] = yield this.analyticsInstance.load(
            { writeKey },
            {
              integrations: { All: false, "Segment.io": true }
            }
          );
          this.analytics = analytics;
          this.context = context;
          yield this.initOptions(options);
        }
      } catch (error) {
        this.logError("Erro ao inicializar Segment", error);
      }
      return this.analytics;
    });
  }
  ready() {
    return __async(this, null, function* () {
      const analytics = this.analytics;
      if (!analytics) {
        console.warn("Analytics ainda n\xE3o inicializado.");
        return;
      }
      return new Promise((resolve) => {
        analytics.ready(() => {
          console.log("Analytics SDK pronto!");
          resolve();
        });
      });
    });
  }
  reset() {
    if (!this.analytics) {
      console.warn("Segment n\xE3o foi inicializado");
      return;
    }
    try {
      console.log("SegmentService.reset", "Resetando analytics");
      return this.analytics.reset();
    } catch (error) {
      this.logError("Erro ao resetar Segment", error);
    }
  }
  loadIntegrations(writeKey) {
    return __async(this, null, function* () {
      if (!this.analyticsInstance) {
        console.warn("Analytics ainda n\xE3o inicializado para carregar integra\xE7\xF5es completas.");
        return;
      }
      if (!this.analytics) {
        console.warn("Inst\xE2ncia base de analytics ainda n\xE3o carregada");
        return;
      }
      try {
        console.log("Carregando integra\xE7\xF5es completas...");
        const [analytics, context] = yield this.analyticsInstance.load(
          { writeKey },
          { integrations: { All: true } }
        );
        this.analytics.track = analytics.track;
        this.analytics.page = analytics.page;
        this.analytics.identify = analytics.identify;
        this.analytics.reset = analytics.reset;
        this.context = context;
      } catch (error) {
        this.logError("Erro ao carregar integra\xE7\xF5es completas", error);
      }
    });
  }
  trackEvent(event, properties) {
    return __async(this, null, function* () {
      if (!this.analytics) {
        console.warn("Segment n\xE3o foi inicializado");
        return;
      }
      yield this.analytics.track(
        event,
        this.appendLocation(properties),
        this.getIntegrationOptions()
      );
    });
  }
  identifyUser(userId, traits) {
    return __async(this, null, function* () {
      if (!this.analytics) {
        console.warn("Segment n\xE3o foi inicializado");
        return;
      }
      yield this.analytics.identify(
        userId,
        this.appendLocation(traits != null ? traits : {}),
        this.getIntegrationOptions()
      );
    });
  }
  pageView(category, name, properties) {
    return __async(this, null, function* () {
      if (!this.analytics) {
        console.warn("Segment n\xE3o foi inicializado");
        return;
      }
      yield this.analytics.page(
        category,
        name,
        this.appendLocation(properties),
        this.getIntegrationOptions()
      );
    });
  }
};
__publicField(_SegmentService, "instance");
var SegmentService = _SegmentService;
var segment_default = SegmentService.getInstance();

// src/events.ts
var trackEvent = (event, properties) => __async(void 0, null, function* () {
  yield segment_default.trackEvent(event, properties);
});
var identifyUser = (userId, traits) => __async(void 0, null, function* () {
  yield segment_default.identifyUser(userId, traits);
});
var trackPageView = (category, name, properties) => __async(void 0, null, function* () {
  yield segment_default.pageView(category, name, properties);
});
var init = (writeKey, options) => __async(void 0, null, function* () {
  return yield segment_default.init(writeKey, options);
});
var ready = () => __async(void 0, null, function* () {
  return yield segment_default.ready();
});
var reset = () => {
  return segment_default.reset();
};
var loadIntegrations = (writeKey) => __async(void 0, null, function* () {
  return yield segment_default.loadIntegrations(writeKey);
});

// src/index.ts
var index_default = { trackPageView, identifyUser, trackEvent, init, ready, reset, loadIntegrations };
export {
  index_default as default,
  identifyUser,
  init,
  loadIntegrations,
  ready,
  reset,
  trackEvent,
  trackPageView
};
//# sourceMappingURL=index.esm.js.map